export const GET_IQROSANTRI_SUCCEED = "iqrosantri/get/succeed";
export const GET_IQROSANTRI_REQUEST = "iqrosantri/get/request";
export const GET_IQROSANTRI_FAILED = "iqrosantri/get/failed";

export const GET_IQROSANTRIAWAL_SUCCEED = "iqrosantri/getawal/succeed";
export const GET_IQROSANTRIAWAL_REQUEST = "iqrosantri/getawal/request";
export const GET_IQROSANTRIAWAL_FAILED = "iqrosantri/getawal/failed";

export const CREATE_IQROSANTRI_REQUEST = "iqrosantri/create/request";
export const CREATE_IQROSANTRI_SUCCEED = "iqrosantri/create/succeed";
export const CREATE_IQROSANTRI_FAILED = "iqrosantri/create/failed";

export const DELETE_IQROSANTRI_REQUEST = "iqrosantri/delete/request";
export const DELETE_IQROSANTRI_SUCCEED = "iqrosantri/delete/succeed";
export const DELETE_IQROSANTRI_FAILED = "iqrosantri/delete/failed";

export const GET_BY_ID_IQROSANTRI_REQUEST = "iqrosantri/getid/request";
export const GET_BY_ID_IQROSANTRI_SUCCEED = "iqrosantri/getid/succeed";
export const GET_BY_ID_IQROSANTRI_FAILED = "iqrosantri/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_IQROSANTRI_REQUEST =
  "iqrosantri/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_IQROSANTRI_SUCCEED =
  "iqrosantri/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_IQROSANTRI_FAILED =
  "iqrosantri/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_IQROSANTRI_REQUEST =
  "iqrosantri/getbyrumahtahfidz/request";
export const GET_BY_MASTERTAHFIDZ_IQROSANTRI_SUCCEED =
  "iqrosantri/getbyrumahtahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_IQROSANTRI_FAILED =
  "iqrosantri/getbyrumahtahfidz/failed";

export const GET_BY_USERID_IQROSANTRI_REQUEST =
  "iqrosantri/getbyuserid/request";
export const GET_BY_USERID_IQROSANTRI_SUCCEED =
  "iqrosantri/getbyuserid/succeed";
export const GET_BY_USERID_IQROSANTRI_FAILED = "iqrosantri/getbyuserid/failed";

export const UPDATE_IQROSANTRI_REQUEST = "iqrosantri/update/request";
export const UPDATE_IQROSANTRI_SUCCEED = "iqrosantri/update/succeed";
export const UPDATE_IQROSANTRI_FAILED = "iqrosantri/update/failed";
